module.exports = __webpack_public_path__ + "static/media/[Lectures_and_Panels]2015-02-02.3a4ed9e3.md";